const sixBTN = document.getElementById("bulk-add-6"); // Replace with your actual element ID
const twelveBTN = document.getElementById("bulk-add-12"); // Replace with your actual element ID

if (sixBTN) {
  sixBTN.addEventListener("click", () => {
    console.log("6 clicked");
    handleAdd(sixBTN, sixBTN.getAttribute("data-variant"), 3);
  });
}

if (twelveBTN) {
  twelveBTN.addEventListener("click", () => {
    console.log("12 clicked");
    handleAdd(twelveBTN, twelveBTN.getAttribute("data-variant"), 6);
  });
}

const handleAdd = (button, var_id, quant) => {
  // Add the "working" class to the button
  button.classList.add("working");

  let formData = {
    items: [
      {
        id: var_id,
        quantity: quant,
      },
    ],
  };
  fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => {
      // Assuming this code is in your other file
      if (window.refreshCart) {
        window.refreshCart();
      } else {
        console.error(
          "window.refreshCart is not defined. Ensure the script containing it has been loaded."
        );
      }

      // Remove the "working" class when the response is received
      button.classList.remove("working");

      return response.json();
    })
    .catch((error) => {
      console.error("Error:", error);

      // Remove the "working" class on error as well
      button.classList.remove("working");
    });
};